import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=efcecb18&scoped=true&"
import script from "./NotFoundPage.vue?vue&type=script&lang=js&"
export * from "./NotFoundPage.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=efcecb18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcecb18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efcecb18')) {
      api.createRecord('efcecb18', component.options)
    } else {
      api.reload('efcecb18', component.options)
    }
    module.hot.accept("./NotFoundPage.vue?vue&type=template&id=efcecb18&scoped=true&", function () {
      api.rerender('efcecb18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/NotFoundPage.vue"
export default component.exports